import WxUtil  from '@/util/WxUtil';
import AppUtil from '@/util/AppUtil';
import Axios from 'axios'
import {Toast} from 'vant'
/**门店信息模型*/
export default class TenantVo {
  id = 0;
  name = "商城";
  /**营业时间*/
  businessHours = "8:00~22:00";
  distance = "暂无";
  address = "";
  addressDetail = "";
  leadPhone = ""
  logo="";
  longitude=0;
  latitude=0;


  private static instance: TenantVo; //类型为这个类
  // private constructor() {}
  // *static 会将它挂载类上，而不是实例上
  static getInstance() {


    if (!this.instance) {
      this.instance = new TenantVo();
      this.req_data();
    }
    // console.log("返回示例对象",this.instance);

    return this.instance;
  }
  // private static async get_data(){
  //   let data=await this.req_data();
  //   console.log("请求到后台数据",data);
  //   return data;
  // }
  /**获取数据 */
  private static req_data() {
    console.log("请求租户信息");
    AppUtil.request({
      url: "/zhTenant/tenant/getTenantInfo",
      method: "post"
  
    }, (res: any) => {
      // this.instance.setData(res.data)
      console.log("设置用户数据",res);
      const data=res.data;
      this.instance.setData(data);
        this.instance.set_share();
      
    });
    // Axios({
    //   url: "/zhTenant/tenant/getTenantInfo",
    //   method: "post"
    // }).then((res: any) => {

    //   const data = res.data;
      

    //   if (data.code != 1) {
    //     Toast(data.msg);
    //   } else { //成功
    //     this.instance.setData(data.data);
    //     this.instance.set_share();
    //   }
    // }).catch((error: any) => {

    //   console.log(error);
    //   if (!error.response) {
    //     return;
    //   }

    // });
  }
   set_share() {
    //设置分享
    console.log("设置分享");
    WxUtil.get_wx().then((wx) => {

      // wx.updateAppMessageShareData({
      //   title: this.name, // 分享标题
      //   desc: this.address , // 分享描述
      //   link: "https://"+window.location.host+"/?appid="+localStorage.getItem("appid"), // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      //   imgUrl: this.thumb, // 分享图标
      //   success: function () {
      //     console.log("设置分享成功");
      //   },
      // });
      // wx.updateTimelineShareData({
      //   title:  this.name, 
      //   link: "https://"+window.location.host+"/?appid="+localStorage.getItem("appid"),
      //   imgUrl: this.thumb, // 分享图标
      //   success: function () {
      //     // 设置成功
      //   },
      // });


      wx.onMenuShareTimeline({
        title: this.name, // 分享标题
        link:"https://"+window.location.host+"/?appid="+localStorage.getItem("appid")+"&tenantId="+this.id, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: this.thumb, // 分享图标
        success: function () {
        // 用户点击了分享后执行的回调函数
        }
      })
      
      wx.onMenuShareAppMessage({
        title: this.name, // 分享标题
        desc: this.address , // 分享描述
        link:"https://"+window.location.host+"/?appid="+localStorage.getItem("appid")+"&tenantId="+this.id, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: this.thumb, // 分享图标
        success: function () {
        // 用户点击了分享后执行的回调函数
        }
      })
    });
  }
   setData(data: any) {
    this.id = data["id"];
    this.name = data["name"];
    /**营业时间*/
    this.businessHours = data["businessHours"];
    this.distance = data["distance"];
    this.address = data["address"];
    this.addressDetail = data["addressDetail"];
    this.leadPhone = data["leadPhone"];
    this.logo=data.logo;
    this.latitude=data.latitude;
    this.longitude=data.longitude;
    console.log("setData",data["name"]);
    
    // document.title =  data["name"];
    console.log("document.title",document.title);
    
    localStorage.setItem("tenantId",data["id"]);
  }
  public get thumb():string{
    // http://image-demo.oss-cn-hangzhou.aliyuncs.com/example.jpg?x-oss-process=image/resize,h_100,m_lfit
    return this.logo ? this.logo + "?x-oss-process=image/resize,w_750,m_lfit":"";
  }
  public get distanceTxt(){
    if(this.id){
      if(!this.distance||this.distance=="暂无"){//如果没有地址，更新用户当前坐标
        //116.036754,39.911282
        let that=this;
        WxUtil.get_wx().then(wx=>{
          wx.getLocation({
            type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            success: function (res:any) {
              // var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
              // var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
              // var speed = res.speed; // 速度，以米/每秒计
              // var accuracy = res.accuracy; // 位置精度
              console.log("获取到坐标",res);
              
              AppUtil.request({
                url:"/zhMember/member/updateMemberCoordinate",
                method:"post",
                data:{
                  latitude:res.latitude,
                  longitude:res.longitude
                }
              },that.update_ok)
            }
          });
        });
        
      }
    }
    
    
    return this.distance;
  }
  private update_ok(res:any){
    console.log("更新坐标成功",res);
    TenantVo.req_data();
  }
  /**营业开始时间() */
  public get startHour() {
    let num = this.businessHours.split("~")[0].split(":")[0];
    return parseInt(num);
  }
  /**营业结束时间 */
  public get endHour() {
    let num = this.businessHours.split("~")[1].split(":")[0];
    // console.log("endHour",num);
    return parseInt(num);
  }
}
